module.exports = require("./ProjectSelect.vue");